import request from '@/utils/request'

export function getsms (data) {
  return request({
    url: '/index/registration/login/getsms',
    method: 'post',
    data
  })
}

export function login (data) {
  return request({
    url: '/index/registration/login/preliminary_login',
    method: 'post',
    data
  })
}

export function register (data) {
  return request({
    url: '/index/registration/login/preliminary_register',
    method: 'post',
    data
  })
}

export function resetpwd (data) {
  return request({
    url: '/index/registration/login/preliminary_resetpwd',
    method: 'post',
    data
  })
}

export function fetchBasic (params) {
  return request({
    url: '/index/registration/preliminary/getBasic',
    method: 'get',
    params
  })
}

export function setBasic (data) {
  return request({
    url: '/index/registration/preliminary/setBasic',
    method: 'post',
    data
  })
}

export function fetchStudentList (params) {
  return request({
    url: '/index/registration/preliminary/getStudentList',
    method: 'get',
    params
  })
}

export function setStudentItem (data) {
  return request({
    url: '/index/registration/preliminary/setStudentItem',
    method: 'post',
    data
  })
}

export function delStudentItem (data) {
  return request({
    url: '/index/registration/preliminary/delStudentItem',
    method: 'post',
    data
  })
}

export function fetchInstructorList (params) {
  return request({
    url: '/index/registration/preliminary/getInstructorList',
    method: 'get',
    params
  })
}

export function delInstructorItem (data) {
  return request({
    url: '/index/registration/preliminary/delInstructorItem',
    method: 'post',
    data
  })
}

export function fetchFileConfig (params) {
  return request({
    url: '/index/registration/preliminary/getFileConfig',
    method: 'get',
    params
  })
}

export function setWorksCnts (data) {
  return request({
    url: '/index/registration/preliminary/setWorksCnts',
    method: 'post',
    data
  })
}

export function submit (data) {
  return request({
    url: '/index/registration/preliminary/submit',
    method: 'post',
    data
  })
}

export function fetchQnUptoken (params) {
  return request({
    url: '/index/registration/preliminary/qn_uptoken',
    method: 'get',
    params
  })
}

export function delQnFile (data) {
  return request({
    url: '/index/registration/preliminary/del_qn_file',
    method: 'post',
    data
  })
}
